import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { jackpotTaxReceiverAddress, jackpotTaxReceiverABI } from '../contract';
const iface = new ethers.Interface(jackpotTaxReceiverABI);
const topic = iface.getEvent('JackpotClaimed').topicHash;
export function decodeLastJackpotClaim(items) {
  const logs = items.filter(log => log.address?.hash?.toLowerCase() === jackpotTaxReceiverAddress.toLowerCase() && log.topics?.[0] === topic)
    .sort((a, b) => b.block_number - a.block_number || b.index - a.index);
  if (!logs.length) return null;
  const log = logs[0];
  const event = iface.parseLog({ topics: log.topics.filter(Boolean), data: log.data });
  return { address: event.args.claimer, amount: ethers.formatUnits(event.args.amount, 18), transactionHash: log.transaction_hash };
}
export default function useLastJackpotClaim(claimPending) {
  const [state, setState] = useState({ claim: null, status: 'loading' });
  useEffect(() => {
    let disposed = false, timer, controller;
    const refresh = async () => {
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch('https://explorer.optimism.io/api/v2/addresses/' + jackpotTaxReceiverAddress + '/logs?topic=' + topic, { signal: controller.signal });
        if (!response.ok) throw new Error('Jackpot history unavailable');
        const data = await response.json();
        if (!Array.isArray(data.items)) throw new Error('Invalid jackpot history');
        const claim = decodeLastJackpotClaim(data.items);
        if (!disposed) setState({ claim, status: claim ? 'ready' : 'empty' });
      } catch {
        if (!disposed) setState(previous => ({ ...previous, status: 'unavailable' }));
      } finally {
        clearTimeout(timeout);
        if (!disposed) timer = setTimeout(refresh, 60000);
      }
    };
    refresh();
    return () => { disposed = true; clearTimeout(timer); controller?.abort(); };
  }, [claimPending]);
  return state;
}
